import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { MapElementShared } from 'src/app/components/shared/models/interface/mapElement.interface';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { MuMapComponent } from 'src/app/components/shared/sharedModules/designSystem/mu-map/mu-map.component';
import { MassiveServiceFlags } from '../../massive-services.flags';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { sameNextDayConstants } from 'src/app/components/same-next-day/same-next-day.constants';
import { PackageDetailShared } from 'src/app/components/shared/models/interface/packageDetail.interface';

@Component({
  selector: 'app-deliveries-map',
  templateUrl: './deliveries-map.component.html',
  styleUrls: ['./deliveries-map.component.sass']
})
export class DeliveriesMapComponent extends MuComponent implements OnChanges {
  @Input() flagList: Flags<MassiveServiceFlags>;
  @Input() markers: MapElementShared[];
  @Input() packageDetail: PackageDetailShared;
  flagEnum = MassiveServiceFlags;
  map: google.maps.Map<Element>;
  mapOptionsFullScreen = sameNextDayConstants.mapOptions;
  mapComponent: MuMapComponent<any>;

  constructor() {
    super();
  }

  muOnInit():void {
    /** */
  }

  muOnDestroy(): void {
    /** */
  }

  /**
   * Capture parametres of input
   * @param changes Changes in Inputs
   */

   ngOnChanges(changes: SimpleChanges): void {
    if (changes.markers?.isFirstChange() || changes.markers?.currentValue !== changes.markers?.previousValue) {
      this.updateMarkers();
    }
  }
  /**
   * Set current map
   * @param map Map to set
   */

  setMap(map: google.maps.Map): void {
    this.map = map;
  }
  /**
   * Event 'eventComponentReady' from mu-map component
   */

  setMapComponent(mapComponent: MuMapComponent<any>): void {
    this.mapComponent = mapComponent;
    this.updateMarkers();
  }
  /**
   * Update markets in map
   */

  updateMarkers(): void {
    if (this.mapComponent) {
      this.mapComponent.updateMarkers(this.markers);
    }
  }
  /**
   * Event to close dialog
   */

  _eventCloseDialogModal(): void {
    this.flagList.disable(this.flagEnum.SHOW_MAP_FULLSCREEN);
  }
}
